import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

export default class CommonRotateDeviceComponent extends Component {
	@action
	closeRotate() {
		document.body.classList.add('hide-rotate');
	}
	<template>
		<div id="rotate">
			<div id="overlay"></div>
			<div id="rotate-content">
				<div class="rotate"></div>
				<p>Please rotate your device to have a better experience</p>
			</div>
			<a role="button" class="close" {{on "click" this.closeRotate}}>
				<CommonUiIconComponent @name="Close" @size="md" />
			</a>
		</div>
	</template>
}
